import { createSlice } from '@reduxjs/toolkit';

import { reducers } from './reducers';
import { SeamRdxState } from './seam-rdx-state';

const initialState: SeamRdxState = { seamComments: [] };

const seamSlice = createSlice({
    name: 'seam',
    initialState,
    reducers,
});

export const SeamSlice = seamSlice.reducer;

export const {
    selectRequest,
    selectPattern,
    setSeamComments,
    setSeamPatterns,
    setOverallMetrics,
    setStoreMetrics,
    setStoreGraphMetrics,
} = seamSlice.actions;
